// let close_announce = document.querySelector(".devCloseAnnounce"),
//   items = document
//     .querySelector(".header__inline-menu")
//     .querySelectorAll("details");
// const menuItems = document.querySelectorAll(".devCustomLevel1 li[data-menu]");
// close_announce &&
//   close_announce.addEventListener("click", function () {
//     let e = this.closest(".utility-bar");
//     e && (e.style.display = "none");
//   }),
//   items.forEach((e) => {
//     e.addEventListener("mouseover", () => {
//       e.setAttribute("open", !0),
//         e.querySelector("ul").addEventListener("mouseleave", () => {
//           e.removeAttribute("open");
//         }),
//         e.addEventListener("mouseleave", () => {
//           e.removeAttribute("open");
//         });
//     });
//   });
let close_announce = document.querySelector(".devCloseAnnounce")
 close_announce.addEventListener("click", function () {
    let e = this.closest(".utility-bar");
    e && (e.style.display = "none");
  })
const links = document.querySelectorAll(".devMegaDrop_menu");

let temp_timeout;
links.forEach((link) => {
  link.addEventListener("mouseenter", (event) => {
    links.forEach((otherLink) => {
      otherLink.removeAttribute("open");
    });
    event.target.setAttribute("open", "open");
    clearTimeout(temp_timeout);
  });
  link.addEventListener("mouseleave", (evt) => {
    temp_timeout = setTimeout((f) => {
      evt.target.closest(".devMegaDrop_menu").removeAttribute("open", "open");
    }, 300);
  });
});
links.forEach((link) => {
  link.addEventListener("click", (event) => {
    links.forEach((otherLink) => {
      otherLink.removeAttribute("open");
    });
    event.target.setAttribute("open", "open");
  });
});
